document.addEventListener('DOMContentLoaded', function() {
  // Envia dados para Google Sheets via App Proxy
  var formEl = document.querySelector('.capture-banner__form');
  if (formEl) {
    formEl.addEventListener('submit', function() {
      var params = new URLSearchParams(window.location.search);
      var data = {
        nome: (formEl.querySelector('[name="contact[first_name]"]') || {}).value || '',
        email: (formEl.querySelector('[name="contact[email]"]') || {}).value || '',
        origem: 'newsletter',
        page_url: window.location.href,
        utm_source: params.get('utm_source') || '',
        utm_medium: params.get('utm_medium') || '',
        utm_campaign: params.get('utm_campaign') || '',
        utm_term: params.get('utm_term') || '',
        utm_content: params.get('utm_content') || ''
      };

      navigator.sendBeacon(
        '/apps/hub-proxy/api/form-submit',
        new Blob([JSON.stringify(data)], { type: 'application/json' })
      );
    });
  }

  const copyButtons = document.querySelectorAll('.success-message__copy-btn');

  copyButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const textToCopy = this.getAttribute('data-copy-text');
      
      // Usar a Clipboard API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy).then(function() {
          // Mostrar feedback visual
          showCopyFeedback(button);
        }).catch(function(err) {
          // Fallback para o método antigo
          fallbackCopy(textToCopy, button);
        });
      } else {
        // Fallback para navegadores mais antigos
        fallbackCopy(textToCopy, button);
      }
    });
  });

  // Feedback visual ao copiar
  function showCopyFeedback(button) {
    const originalSvg = button.innerHTML;
    
    // Mudar para checkmark
    button.innerHTML = `
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.4142 20.5858L8 15.1716L6.58579 16.5858L13.4142 23.4142L27.4142 9.41421L26 8L13.4142 20.5858Z" fill="#28A745"/>
      </svg>
    `;
    
    button.style.opacity = '0.8';
    
    // Restaurar ícone original após 2 segundos
    setTimeout(function() {
      button.innerHTML = originalSvg;
      button.style.opacity = '1';
    }, 2000);
  }

  // Fallback para copiar texto
  function fallbackCopy(text, button) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    
    try {
      document.execCommand('copy');
      showCopyFeedback(button);
    } catch (err) {
      console.error('Erro ao copiar:', err);
    }
    
    document.body.removeChild(textarea);
  }
});
